import { useTranslations } from 'next-intl';
import { FC } from 'react';

interface ILanguagePair {
  sourceLanguageCode: string;
  targetLanguageCode: string;
}

const LanguagePair: FC<ILanguagePair> = ({ sourceLanguageCode, targetLanguageCode }) => {
  const t = useTranslations();

  if (!sourceLanguageCode || !targetLanguageCode) return null;

  return (
    <>{`${t(`languages.${sourceLanguageCode}` as any)} - ${t(
      `languages.${targetLanguageCode}` as any
    )}`}</>
  );
};

export default LanguagePair;
